import { CustomButton, CustomTextInput, CustomInputSelect } from "@Modules/core/components";
import CustomFormControl from "@Modules/core/components/form/CustomFormControl";
import { IAuthorizationsConsultationFormMeta } from '@Modules/admin/archiving/containers/mixedHandlers/archivedTables/authorizationsConsultation/AuthorizationsConsultationMeta';
import { ChakraComponents as CC } from "@Modules/core/lib/chakra";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FaSave } from "react-icons/fa";


type Props = {
  onSubmit: any,
  meta: IAuthorizationsConsultationFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
} 

const AuthorizationsConsultationFormUI = ({onSubmit, isLoading, isSubmitting, meta}: Props) => {

    const {
        register,
        handleSubmit,
        formState: { errors },
        // reset,
      } = useForm({ resolver: yupResolver(meta.schema),});
    
  return (
    <>
        <form onSubmit={handleSubmit(onSubmit)}>        
        <CC.Box my="4" mb='8'>

        <CC.Box as="fieldset" border={CC.useColorModeValue('1px solid #E2E8F0', '1px solid #444')}
        width={'100%'} px={5} my={10}>          
          <CC.SimpleGrid columns={{base: 1, sm:1, md: 2, lg:3}} spacing={10} my={10}>
            <CustomFormControl
              label={meta.receivingBank.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.receivingBank.name]}
            >
              <CustomInputSelect
                meta={meta.receivingBank}
                register={register(meta.receivingBank.name)}
                hasError={errors[meta.receivingBank.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.sendingBank.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.sendingBank.name]}
            >
              <CustomInputSelect
                meta={meta.sendingBank}
                register={register(meta.sendingBank.name)}
                hasError={errors[meta.sendingBank.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.authorizationNumber.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.authorizationNumber.name]}
            >
              <CustomTextInput
                meta={meta.authorizationNumber}
                register={register(meta.authorizationNumber.name)}
                hasError={errors[meta.authorizationNumber.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.sellerNumber.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.sellerNumber.name]}
            >
              <CustomInputSelect
                meta={meta.sellerNumber}
                register={register(meta.sellerNumber.name)}
                hasError={errors[meta.sellerNumber.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.cardNumber.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.cardNumber.name]}
            >
              <CustomTextInput
                meta={meta.cardNumber}
                register={register(meta.cardNumber.name)}
                hasError={errors[meta.cardNumber.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.startDate.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.startDate.name]}
            >
              <CustomTextInput
                meta={meta.startDate}
                register={register(meta.startDate.name)}
                hasError={errors[meta.startDate.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.endDate.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.endDate.name]}
            >
              <CustomTextInput
                meta={meta.endDate}
                register={register(meta.endDate.name)}
                hasError={errors[meta.endDate.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.noNameSelect.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.noNameSelect.name]}
            >
              <CustomInputSelect
                meta={meta.noNameSelect}
                register={register(meta.noNameSelect.name)}
                hasError={errors[meta.noNameSelect.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.noNameTextInput.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.noNameTextInput.name]}
            >
              <CustomTextInput
                meta={meta.noNameTextInput}
                register={register(meta.noNameTextInput.name)}
                hasError={errors[meta.noNameTextInput.name]}
              />
            </CustomFormControl>


          </CC.SimpleGrid>
        </CC.Box>
          

          <CC.Flex justify={'flex-end'}>
            <CustomButton isLoading={isSubmitting} type="submit" mr="4">
              <span>Afficher</span>
            </CustomButton>
          </CC.Flex>
          
        </CC.Box>
      </form>
    </>    
  )
}

export default AuthorizationsConsultationFormUI;